import React, { useState, useEffect, ReactNode, useMemo } from "react"
import { ThemeProvider } from "emotion-theming"
import {
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
} from "@material-ui/core/styles"
import { customMUTheme, defaultThemeValues } from "./styles"
import Auth from "../Auth/Auth"
import AuthContext from "../context/AuthContext"
import { useHistory } from "react-router-dom"
import { LinearProgress } from "@material-ui/core"
import { CartProvider } from "../context/CartContext"
import { QueryClient, QueryClientProvider } from "react-query"

function AppProvider({ children }: { children: ReactNode }) {
  const history = useHistory()
  const queryClient = useMemo(() => new QueryClient(), [])
  const [auth] = useState(new Auth(history))
  const [tokenRenewalComplete, setTokenRenewalComplete] = useState(false)

  useEffect(() => {
    auth.renewToken((error) => {
      if (error && auth.isAuthenticated() !== undefined) {
        alert("Could not renew token")
        console.error(error)
      }
      setTokenRenewalComplete(true)
    })
  }, [auth])

  if (!tokenRenewalComplete) return <LinearProgress />

  return (
    <MuiThemeProvider theme={{ ...customMUTheme, ...defaultThemeValues }}>
      <ThemeProvider theme={{ ...customMUTheme, ...defaultThemeValues }}>
        <StylesProvider injectFirst>
          <QueryClientProvider client={queryClient}>
            <CartProvider>
              <AuthContext.Provider value={auth}>
                {children}
              </AuthContext.Provider>
            </CartProvider>
          </QueryClientProvider>
        </StylesProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  )
}

export default AppProvider
